// WIP

import get from 'lodash/get';
import siteData from './site_data_util';
import baseSeoUtil from './base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData[site] || {};
  const year = get(state, 'micSector.year');

  return baseSeoUtil({
    site,
    siteConf,
    title: `The Most Innovative Companies of ${year} by Sector`,
    url: `https://www.fastcompany.com//most-innovative-companies/${year}/sectors`,
    description: `The ${year} guide to the businesses that matter the most by Sector`,
    image: `http://fast-company-res.cloudinary.com/image/upload/h_400,c_scale/w_500/v1479418220/fcweb/MIC-Sector-Logo-OG.png`,
    articleSection: 'Most Innovative Companies'
  });
}



// WEBPACK FOOTER //
// ./src/utils/seo_utils/mic_sector_page_seo_util.js